import React, {useEffect, useState} from 'react';
import PaymentSuccessful from "../resource/figma-images/payment-successful.svg";
import PaymentFailed from "../resource/figma-images/payment-failed.svg";
import {Instruction, PageTitle, ResultContainerContent} from "./CommonStyledComponent";
import {Dialog, styled} from "@mui/material";

const DialogContainer = styled('div')`
  border-radius: 10px;
  padding: 50px 10px 30px;
  align-items: center;
  @media (min-width: 500px) {
    width: 370px;
  }
`

export const FlashDialog = ({ paymentStatus }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (paymentStatus) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [paymentStatus]);

  return (
    <Dialog open={visible}>
      <DialogContainer>
        { paymentStatus === 'PAY_SUCCESS' ? (
          <ResultContainerContent>
            <img src={PaymentSuccessful} alt="Payment Successful" />
            <PageTitle>Payment Successful</PageTitle>
            <Instruction>Thank you for paying your fees.</Instruction>
          </ResultContainerContent>
        ) : paymentStatus === 'PAY_ERROR' ? (
          <ResultContainerContent>
            <img src={PaymentFailed} alt="Payment Failed" />
            <PageTitle>Payment Failed</PageTitle>
            <Instruction>We are sorry, there was an error processing your payment.</Instruction>
          </ResultContainerContent>
        ) : null}
      </DialogContainer>
    </Dialog>
  )
}
